module.exports = __webpack_public_path__ + "static/img/DK.510f0e8b.svg";